import React, { useRef } from "react";

// third party
import { BannerModalAlert, HorizonButton, HorizonText, TextVariant } from "@urbanpiper-engineering/horizon";

const BannerModalAlertWrapper = ({ banner = {}, modal = {}, onClose, handleLink }) => {
	const ref = useRef(null);

	const closeModal = () => {
		if (ref.current) {
			ref.current.closeModal();
		}
	};

	const bannerLinkCallback = () => {
		if (handleLink) {
			handleLink();
		}
	};

	return (
		<BannerModalAlert
			ref={ref}
			bannerClass={banner?.bannerClass || "h-[57px] box-border"}
			bannerMessage={banner?.bannerMessage || ""}
			bannerMessageVariant={banner?.bannerMessageVariant || TextVariant.BODY1}
			bannerMessageClass={banner?.bannerMessageClass || "text-up-black-80"}
			bannerLink={banner?.bannerLink || ""}
			bannerLinkCallback={bannerLinkCallback}
			bannerProps={{
				status: banner?.bannerStatus || "info",
				onClose: onClose,
				...(banner?.bannerProps || {})
			}}
			modalCover={
				modal?.modalCover ? (
					<img className={"w-full object-cover " + modal?.modalCoverClass} src={modal?.modalCover} alt="" />
				) : null
			}
			modalCoverClass={modal?.modalCoverWrapperClass || "bg-up-blue-5 rounded-s-sm"}
			modalBody={
				modal?.modalBody?.length > 0 ? (
					<div className="flex flex-col">
						{modal?.modalBody?.map((item, i) => (
							<HorizonText
								key={i}
								className={item?.className || ""}
								variant={item?.variant || TextVariant.BODY1}
							>
								{typeof item?.text === "string"
									? item?.text || ""
									: item?.text?.length > 0
										? item?.text?.map((text, j) => <p key={j}>{text}</p>)
										: ""}
							</HorizonText>
						))}
						<div className="flex justify-end gap-3">
							{modal?.modalActions?.map((action, i) => (
								<HorizonButton
									key={i}
									className="w-min"
									onClick={closeModal}
									size="small"
									type="primary"
									{...(action?.buttonProps ?? {})}
								>
									{action.text}
								</HorizonButton>
							))}
						</div>
					</div>
				) : null
			}
			modalBodyClass={modal?.modalBodyClass}
			modalProps={{
				width: 800,
				maskClosable: false,
				keyboard: false,
				...(modal?.modalProps ?? {})
			}}
			modalAlignment={modal?.modalAlignment || "horizontal"}
		/>
	);
};
export default BannerModalAlertWrapper;
